export const themeConfigStore = {
    theme: ''
};
